import React, { useState } from "react";
import "./Whatsapp.css";

const Whatsapp = () => {
  const [filter, setFilter] = useState("all");
  const [mode, setMode] = useState("bot"); // bot | human

  const conversations = [
    {
      id: 1,
      name: "João Silva",
      phone: "+55 11 9••••-1234",
      tag: "Novo lead",
      stage: "Novo contato",
      lastMessage: "Sim, quero um orçamento para 50kWp.",
      lastTime: "10:21",
      unread: 3,
      channel: "WhatsApp",
      slaRisk: false,
      handledBy: "bot",
    },
    {
      id: 2,
      name: "H2 Brasil",
      phone: "+55 21 9••••-9876",
      tag: "Cobrança D+3",
      stage: "Em atendimento",
      lastMessage: "Podemos pagar até sexta-feira.",
      lastTime: "10:10",
      unread: 0,
      channel: "WhatsApp",
      slaRisk: true,
      handledBy: "human",
    },
    {
      id: 3,
      name: "SolarTech",
      phone: "+55 31 9••••-4455",
      tag: "Suporte pós-venda",
      stage: "Qualificado",
      lastMessage: "Obrigado, o problema foi resolvido.",
      lastTime: "09:52",
      unread: 0,
      channel: "WhatsApp",
      slaRisk: false,
      handledBy: "bot",
    },
    {
      id: 4,
      name: "Maria Oliveira",
      phone: "+55 48 9••••-2222",
      tag: "Reativação",
      stage: "Em atendimento",
      lastMessage: "Faz tempo que não falo com o time.",
      lastTime: "Ontem",
      unread: 1,
      channel: "WhatsApp",
      slaRisk: true,
      handledBy: "bot",
    },
  ];

  const filteredConversations = conversations.filter((c) => {
    if (filter === "all") return true;
    if (filter === "unread") return c.unread > 0;
    if (filter === "sla") return c.slaRisk;
    if (filter === "bot") return c.handledBy === "bot";
    if (filter === "human") return c.handledBy === "human";
    return true;
  });

  const [selectedId, setSelectedId] = useState(conversations[0].id);
  const selectedConv =
    conversations.find((c) => c.id === selectedId) || conversations[0];

  const messagesByConv = {
    1: [
      {
        from: "client",
        time: "10:18",
        text: "Oi, vi o anúncio de vocês no Instagram.",
      },
      {
        from: "bot",
        time: "10:18",
        text: "Olá, João! Sou o assistente virtual da FASTEAM. Você procura projeto, implantação ou manutenção?",
      },
      {
        from: "client",
        time: "10:19",
        text: "Projeto + implantação.",
      },
      {
        from: "bot",
        time: "10:20",
        text: "Perfeito! Só para contextualizar, qual tamanho aproximado da usina (em kWp)?",
      },
      {
        from: "client",
        time: "10:21",
        text: "Sim, quero um orçamento para 50kWp.",
      },
    ],
    2: [
      {
        from: "bot",
        time: "10:05",
        text: "Oi, aqui é o financeiro da FASTEAM. Identamos uma fatura em aberto há 3 dias. Posso te enviar o link para pagamento?",
      },
      {
        from: "client",
        time: "10:08",
        text: "Podemos pagar até sexta-feira.",
      },
      {
        from: "human",
        time: "10:10",
        text: "Sem problemas! Vou atualizar aqui e te envio um lembrete na quinta, tudo bem?",
      },
    ],
    3: [
      {
        from: "client",
        time: "09:40",
        text: "Estou com problema no painel de monitoramento.",
      },
      {
        from: "bot",
        time: "09:40",
        text: "Consegue me enviar um print do erro?",
      },
      {
        from: "client",
        time: "09:43",
        text: "Enviei o print.",
      },
      {
        from: "human",
        time: "09:50",
        text: "Já identifiquei aqui, era apenas uma atualização pendente. Já está normalizado.",
      },
      {
        from: "client",
        time: "09:52",
        text: "Obrigado, o problema foi resolvido.",
      },
    ],
    4: [
      {
        from: "bot",
        time: "Ontem 18:55",
        text: "Oi, faz tempo que não falamos! Quer ver as novidades e oportunidades para reduzir sua conta?",
      },
      {
        from: "client",
        time: "Ontem 18:58",
        text: "Faz tempo que não falo com o time.",
      },
    ],
  };

  const templates = [
    {
      id: 1,
      name: "Boas-vindas – Novo lead",
      category: "Aquisição",
      text: "Olá, {{nome}}! Obrigado por entrar em contato 👋 Sou do time {{empresa}}. Me conta rapidinho: você procura projeto, implantação ou manutenção?",
    },
    {
      id: 2,
      name: "Cobrança D+3 amigável",
      category: "Financeiro",
      text: "Oi, {{nome}}! Aqui é do financeiro da {{empresa}}. Notamos uma fatura em aberto há alguns dias. Posso te enviar o link de pagamento?",
    },
    {
      id: 3,
      name: "Pós-venda – Satisfação",
      category: "Suporte",
      text: "Olá, {{nome}}! Passando para saber se está tudo bem com o seu projeto. De 0 a 10, quanto você recomendaria nossa empresa?",
    },
  ];

  const [selectedTemplateId, setSelectedTemplateId] = useState(null);

  const handleSend = () => {
    // Placeholder para envio
    alert(
      selectedTemplateId
        ? "Mensagem enviada usando template selecionado ✅"
        : "Mensagem enviada ✅"
    );
  };

  return (
    <div className="Whatsapp">
      {/* Cabeçalho */}
      <header className="wa-header">
        <div>
          <p className="wa-kicker">WhatsApp Automation</p>
          <h1 className="wa-title">Atendimento e vendas em escala</h1>
          <p className="wa-subtitle">
            Centralize as conversas de WhatsApp, combine bot + time humano,
            ative funis conversacionais e monitore SLAs de atendimento.
          </p>
        </div>
        <div className="wa-header-actions">
          <div className="wa-mode-toggle">
            <button
              className={
                mode === "bot"
                  ? "wa-mode-btn wa-mode-btn-active"
                  : "wa-mode-btn"
              }
              onClick={() => setMode("bot")}
            >
              Responder como Bot
            </button>
            <button
              className={
                mode === "human"
                  ? "wa-mode-btn wa-mode-btn-active"
                  : "wa-mode-btn"
              }
              onClick={() => setMode("human")}
            >
              Assumir como Humano
            </button>
          </div>
          <button className="wa-btn-secondary">Ver campanhas ativas</button>
          <button className="wa-btn-primary">+ Criar funil de WhatsApp</button>
        </div>
      </header>

      {/* Métricas gerais */}
      <section className="wa-metrics">
        <div className="wa-metric-card">
          <span className="label">Tempo médio de primeira resposta</span>
          <strong>11s</strong>
          <span className="hint">vs 1m52s no atendimento manual</span>
        </div>
        <div className="wa-metric-card">
          <span className="label">Conversas nas últimas 24h</span>
          <strong>482</strong>
          <span className="hint">63% atendidas totalmente pelo bot</span>
        </div>
        <div className="wa-metric-card">
          <span className="label">Conversão em oportunidades</span>
          <strong>27%</strong>
          <span className="hint">via funis conversacionais configurados</span>
        </div>
        <div className="wa-metric-card">
          <span className="label">Falhas do bot</span>
          <strong>7</strong>
          <span className="hint">todas redirecionadas para humanos</span>
        </div>
      </section>

      {/* Layout principal */}
      <section className="wa-main">
        {/* Coluna esquerda: inbox */}
        <div className="wa-column wa-column-inbox">
          <div className="wa-card wa-inbox-card">
            <div className="wa-card-header">
              <h2>Caixa de entrada</h2>
              <p>Visualize e priorize as conversas em WhatsApp.</p>
            </div>

            <div className="wa-filters">
              <button
                className={
                  filter === "all" ? "wa-filter-btn wa-filter-btn-active" : "wa-filter-btn"
                }
                onClick={() => setFilter("all")}
              >
                Todos
              </button>
              <button
                className={
                  filter === "unread"
                    ? "wa-filter-btn wa-filter-btn-active"
                    : "wa-filter-btn"
                }
                onClick={() => setFilter("unread")}
              >
                Não lidos
              </button>
              <button
                className={
                  filter === "bot"
                    ? "wa-filter-btn wa-filter-btn-active"
                    : "wa-filter-btn"
                }
                onClick={() => setFilter("bot")}
              >
                Bot
              </button>
              <button
                className={
                  filter === "human"
                    ? "wa-filter-btn wa-filter-btn-active"
                    : "wa-filter-btn"
                }
                onClick={() => setFilter("human")}
              >
                Humanos
              </button>
              <button
                className={
                  filter === "sla"
                    ? "wa-filter-btn wa-filter-btn-active"
                    : "wa-filter-btn"
                }
                onClick={() => setFilter("sla")}
              >
                SLA em risco
              </button>
            </div>

            <ul className="wa-conv-list">
              {filteredConversations.map((conv) => (
                <li
                  key={conv.id}
                  className={
                    conv.id === selectedId
                      ? "wa-conv-item wa-conv-item-active"
                      : "wa-conv-item"
                  }
                  onClick={() => setSelectedId(conv.id)}
                >
                  <div className="wa-conv-main">
                    <div className="wa-conv-top">
                      <span className="wa-conv-name">{conv.name}</span>
                      <span className="wa-conv-time">{conv.lastTime}</span>
                    </div>
                    <p className="wa-conv-last">{conv.lastMessage}</p>
                    <div className="wa-conv-tags">
                      <span className="wa-tag">{conv.tag}</span>
                      <span className="wa-tag wa-tag-stage">{conv.stage}</span>
                      <span
                        className={
                          conv.handledBy === "bot"
                            ? "wa-tag wa-tag-bot"
                            : "wa-tag wa-tag-human"
                        }
                      >
                        {conv.handledBy === "bot" ? "Bot" : "Humano"}
                      </span>
                      {conv.slaRisk && (
                        <span className="wa-tag wa-tag-sla">SLA em risco</span>
                      )}
                    </div>
                  </div>
                  {conv.unread > 0 && (
                    <span className="wa-unread">{conv.unread}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Coluna central: conversa */}
        <div className="wa-column wa-column-chat">
          <div className="wa-card wa-chat-card">
            <div className="wa-card-header wa-chat-header">
              <div>
                <h2>{selectedConv.name}</h2>
                <p className="wa-chat-subtitle">
                  {selectedConv.phone} • {selectedConv.tag} •{" "}
                  {selectedConv.stage}
                </p>
              </div>
              <div className="wa-chat-status">
                <span
                  className={
                    selectedConv.handledBy === "bot"
                      ? "wa-pill wa-pill-bot"
                      : "wa-pill wa-pill-human"
                  }
                >
                  {selectedConv.handledBy === "bot"
                    ? "Fluxo automatizado ativo"
                    : "Atendido por humano"}
                </span>
                {selectedConv.slaRisk && (
                  <span className="wa-pill wa-pill-sla">
                    SLA em risco — priorizar
                  </span>
                )}
              </div>
            </div>

            <div className="wa-chat-body">
              <div className="wa-messages">
                {(messagesByConv[selectedConv.id] || []).map(
                  (msg, index) => (
                    <div
                      key={index}
                      className={
                        msg.from === "client"
                          ? "wa-msg wa-msg-client"
                          : msg.from === "bot"
                          ? "wa-msg wa-msg-bot"
                          : "wa-msg wa-msg-human"
                      }
                    >
                      <div className="wa-msg-meta">
                        <span className="wa-msg-from">
                          {msg.from === "client" && "Cliente"}
                          {msg.from === "bot" && "Bot FASTEAM"}
                          {msg.from === "human" && "Você / Time"}
                        </span>
                        <span className="wa-msg-time">{msg.time}</span>
                      </div>
                      <p className="wa-msg-text">{msg.text}</p>
                    </div>
                  )
                )}
              </div>
            </div>

            {/* Composer */}
            <div className="wa-composer">
              <div className="wa-composer-top">
                <select
                  className="wa-template-select"
                  value={selectedTemplateId || ""}
                  onChange={(e) =>
                    setSelectedTemplateId(
                      e.target.value ? Number(e.target.value) : null
                    )
                  }
                >
                  <option value="">
                    Selecionar template oficial do WhatsApp...
                  </option>
                  {templates.map((tpl) => (
                    <option key={tpl.id} value={tpl.id}>
                      {tpl.name} — {tpl.category}
                    </option>
                  ))}
                </select>
                <button className="wa-quick-replies-btn">
                  Ver respostas rápidas
                </button>
              </div>
              <div className="wa-composer-bottom">
                <textarea
                  className="wa-textarea"
                  rows={2}
                  placeholder={
                    selectedTemplateId
                      ? "Pré-visualização do template selecionado (campos como {{nome}} serão preenchidos automaticamente)..."
                      : mode === "bot"
                      ? "Escreva ou selecione uma resposta para treinar o bot neste cenário..."
                      : "Digite sua resposta para o cliente..."
                  }
                />
                <div className="wa-composer-actions">
                  <span className="wa-composer-hint">
                    {mode === "bot"
                      ? "A resposta será registrada como aprendizado do bot e usada em fluxos futuros."
                      : "A resposta será enviada como humano e o bot ficará em segundo plano."}
                  </span>
                  <button className="wa-send-btn" onClick={handleSend}>
                    Enviar mensagem
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Coluna direita: SLA, funil, bot health */}
        <div className="wa-column wa-column-side">
          <div className="wa-card wa-side-card">
            <h2>SLA e funil de WhatsApp</h2>
            <div className="wa-sla-grid">
              <div className="wa-sla-item">
                <span className="label">SLA de primeira resposta</span>
                <strong>30s</strong>
                <span className="hint">Configurado para este time</span>
              </div>
              <div className="wa-sla-item">
                <span className="label">% dentro do SLA (24h)</span>
                <strong>92%</strong>
                <span className="hint">conversas respondidas a tempo</span>
              </div>
            </div>

            <div className="wa-funnel">
              <span className="wa-section-title">Funil conversacional</span>
              <div className="wa-funnel-steps">
                <div className="wa-funnel-step">
                  <span>Novo contato</span>
                  <strong>100%</strong>
                </div>
                <div className="wa-funnel-step">
                  <span>Em atendimento</span>
                  <strong>74%</strong>
                </div>
                <div className="wa-funnel-step">
                  <span>Qualificado</span>
                  <strong>39%</strong>
                </div>
                <div className="wa-funnel-step">
                  <span>Convertido</span>
                  <strong>27%</strong>
                </div>
              </div>
            </div>

            <div className="wa-bot-health">
              <span className="wa-section-title">Desempenho do bot</span>
              <ul className="wa-bot-metrics">
                <li>
                  <span>Mensagens resolvidas só pelo bot</span>
                  <strong>63%</strong>
                </li>
                <li>
                  <span>Transferências automáticas para humanos</span>
                  <strong>18%</strong>
                </li>
                <li>
                  <span>Conversas onde o bot falhou</span>
                  <strong>7</strong>
                </li>
              </ul>
              <p className="wa-bot-note">
                Fluxos de fallback garantem que qualquer falha do bot seja
                encaminhada automaticamente para um atendente, sem o cliente
                ficar sem resposta.
              </p>
            </div>
          </div>

          <div className="wa-card wa-side-card wa-side-card-mini">
            <h2>Sugestões de melhorias</h2>
            <ul className="wa-suggestions">
              <li>
                O funil de <strong>reativação</strong> está com conversão baixa (6%).
                Considere ajustar a mensagem inicial.
              </li>
              <li>
                Alguns clientes pedem <strong>falar direto com humano</strong>. Que tal
                criar um atalho “Falar com atendente”?
              </li>
              <li>
                Crie um fluxo específico para <strong>pós-instalação</strong> com fotos e
                depoimentos para aumentar a satisfação.
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Whatsapp;
